import React, {useCallback, useEffect, useState} from 'react'
import Page from '../../../Components/Page'
import {PortalType, SlotPortal} from '../../../Components/Portal'
import Breadcrumbs from '../../../Components/Breadcrumbs'
import {useNavigation} from '../../../utils/navigation'
import classNames from 'classnames'
import styles from '../../../../CSS/main.css'
import {Col} from '../../../Components/List/Col'
import Box from '../../../Components/Box'
import {formatDate} from '../../../utils/date'
import {formatNumber} from '../../../utils/number'
import CommentActions from "../CommentActions";
import {useParams} from "react-router-dom";
import {Comment} from "../../../Components/List/Item/CommentsItem";
import Spinner from "../../../Components/Spinner";
import {getCommentById, getParentCommentById, postCommentAction} from "../../../api/requests";
import { Routes, TypedLink } from '../../../routing'
import { showError } from '../../../Components/Toast'

const cssImage = (index: number) => {
  switch (index) {
    case 1:
      return styles.MediaCard1
    case 2:
      return styles.MediaCard2
    case 3:
      return styles.MediaCard3
    case 4:
      return styles.MediaCard4
    default:
      return styles.MediaCard1
  }
}

const CommentDetails: React.VFC = () => {
  const { goBack, goToNoParams } = useNavigation()
  const { id: idStr } = useParams<{id?: string}>()
  const id = parseInt(idStr)
  const [comment, setComment] = useState<Comment | null>(null)

  useEffect(() => {
    getCommentById(id).then(setComment)
  }, [id])


  const onAction = useCallback(async (type: string, id: number) => {
    await postCommentAction(type, [id])
  }, [])

  const onApprove = useCallback(async () => {
    await onAction('approve', id)
    setComment({...comment, approved: true, rejected: false})
  }, [id, comment])

  const onBlock = useCallback( async () => {
    await onAction('block', id)
    setComment({...comment, approved: false, rejected: true})
  }, [id, comment])

  const handleChangeStatus = useCallback(async (type: string) => {
    if (comment.targetTo || comment.replyTo) {
      const checkParent = await getParentCommentById(comment.targetTo || comment.replyTo)
      if (!checkParent) {
        await onAction('delete', id)
        showError('This comment was deleted')
        return goToNoParams(Routes.Comments)
      }
    }
    return type === 'approve' ? onApprove() : onBlock()
  }, [id, comment])

  return (
    <Page isInfoPage>
      <SlotPortal name={PortalType.Toolbar}>
        <Breadcrumbs onBack={goBack} title={'Review Comment'} />
        {!comment ? (
          <Spinner/>
        ) : (
          <div className={classNames([styles.Table, styles.Layout2Col])}>
            <Col>
              <Box>
                <div className={styles.ReviewProfile}>
                  <div className={styles.ReviewPic}>
                    {/*<TypedLink*/}
                    {/*  to={Routes.EditUser}*/}
                    {/*  params={{ id: comment.User.id }}>*/}
                    <div
                      className={styles.Avatar}
                      style={{ backgroundImage: `url(${comment.avatar})` }}
                    />
                    {/*</TypedLink>*/}
                  </div>
                  <div className={styles.ReviewName}>
                    {/*<TypedLink*/}
                    {/*  to={Routes.EditUser}*/}
                    {/*  params={{ id: comment.User.id }}>*/}
                    <b>{comment.displayName}</b>
                    {/*</TypedLink>{' '}*/}
                    // Posted {formatDate(comment.createdAt)}
                    <br />
                    <div className={styles.Comment} dangerouslySetInnerHTML={{ __html: comment.comment }} />
                    <div className={styles.Media}>
                      {Boolean(comment.images.length) && comment.images.map((url, index) => (
                        <div className={`${styles.MediaCard} ${cssImage(comment.images.length)}`} key={index}>
                            <img src={url} alt="" />
                        </div>
                      ))}
                    </div>
                    </div>
                </div>

                <div className={styles.TextGroup}>
                    <CommentActions comment={comment} onApprove={() => handleChangeStatus('approve')} onBlock={() => handleChangeStatus('block')} />
                </div>

                <div className={styles.TextGroup}>
                  <div className={styles.MenuHeader}>More Information</div>
                  <p>
                    This comment appears at:
                    <b>
                      {' '}
                      <a href={comment.origin} target='_blank'>
                        {comment.origin}
                      </a>
                    </b>
                  </p>
                  <ul>
                    <li>
                      Likes: <b>{formatNumber(comment.likes)}</b>
                    </li>
                    <li>
                      Dislikes: <b>{formatNumber(comment.dislikes)}</b>
                    </li>
                    <li>
                      Flagged: <b>{formatNumber(comment.countFlag)}</b>
                    </li>
                  </ul>
                </div>

                  {/* <div className={styles.TextGroup}>
                    <div className={styles.MenuHeader}>Filter Triggers</div>
                    <p>
                      <b>
                        Filtered words found in this comment:{' '}
                        <span className={styles.Alert}>{12}</span>
                      </b>
                    </p>
                  </div> */}

                  <div className={styles.TextGroup}>
                    <div className={styles.MenuHeader}>Comment history</div>
                    <TypedLink
                      to={Routes.CommentHistory}
                      params={{ id: comment.id }}>
                      Review All History
                    </TypedLink>
                  </div>
              </Box>
            </Col>
            <Col>
              {/*<StatsPanel title={'User Stats'} stats={MOCK_USER_STATS} />*/}
            </Col>
          </div>
        )}

      </SlotPortal>
    </Page>
  )
}

export default CommentDetails
